import { render, staticRenderFns } from "./BulkUploadFeedback.vue?vue&type=template&id=1c3ac17f&"
import script from "./BulkUploadFeedback.vue?vue&type=script&lang=js&"
export * from "./BulkUploadFeedback.vue?vue&type=script&lang=js&"
import style0 from "./BulkUploadFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports